export const mailType = {
  CONTACT_ACTIVATION: 'CONTACT_ACTIVATION',
  CONTACT_OF_RESIDENT_BEGIN: 'CONTACT_OF_RESIDENT_BEGIN',
  CONTACT_OF_RESIDENT_END: 'CONTACT_OF_RESIDENT_END',
  CONTACT_PASSWORD_RESET: 'CONTACT_PASSWORD_RESET',
  CONTACT_PASSWORD_SELECTED: 'CONTACT_PASSWORD_SELECTED',
  CONTACT_WELCOME: 'CONTACT_WELCOME',
  INCITE_TO_DOWNLOAD_FIRST: 'INCITE_TO_DOWNLOAD_FIRST',
  INCITE_TO_DOWNLOAD_SECOND: 'INCITE_TO_DOWNLOAD_SECOND',
  ETS_MESSAGE_TO_FAMILY: 'ETS_MESSAGE_TO_FAMILY',
  FAMILY_ACCOUNT_DELETED: 'FAMILY_ACCOUNT_DELETED',
  FAMILY_TO_ETS_MESSAGE: 'FAMILY_TO_ETS_MESSAGE',
  PRO_PASSWORD_RESET: 'PRO_PASSWORD_RESET',
  PRO_PASSWORD_SELECTED: 'PRO_PASSWORD_SELECTED',
  PRO_OFFER_WELCOME: 'PRO_OFFER_WELCOME',
  PRO_HEADQUARTER_WELCOME: 'PRO_HEADQUARTER_WELCOME',
  NEF_PETIT_JOURNAL_RESIDENCE: 'NEF_PETIT_JOURNAL_RESIDENCE',
  NEF_PETIT_JOURNAL_RESIDENT: 'NEF_PETIT_JOURNAL_RESIDENT',
  NO_PETIT_JOURNAL_ETABLISSEMENT: 'NO_PETIT_JOURNAL_ETABLISSEMENT',
  NO_PETIT_JOURNAL_PERSONNALISE: 'NO_PETIT_JOURNAL_PERSONNALISE',
  NO_REFERENT_OF_RESIDENT: 'NO_REFERENT_OF_RESIDENT',
  PERIODE_PETIT_JOURNAL_CHANGED: 'PERIODE_PETIT_JOURNAL_CHANGED',
  PERIODE_PETIT_JOURNAL_ETABLISSEMENT: 'PERIODE_PETIT_JOURNAL_ETABLISSEMENT',
  PERIODE_PETIT_JOURNAL_PERSONNALISE: 'PERIODE_PETIT_JOURNAL_PERSONNALISE',
  REFERENT_OF_RESIDENT: 'REFERENT_OF_RESIDENT',
  RESIDENT_APPEL_CONCIERGE: 'RESIDENT_APPEL_CONCIERGE',
  RESIDENT_DEBUT_SEJOUR: 'RESIDENT_DEBUT_SEJOUR',
  RESIDENT_INVITE_CONTACT: 'RESIDENT_INVITE_CONTACT',
} as const;

export type MailType = (typeof mailType)[keyof typeof mailType];
